<template>
  <div>
    <v-data-table
      v-if="protocol.tasks?.length"
      :disable-pagination="true"
      :headers="protocolTaskHeaders"
      hide-default-header
      :items="protocol.tasks || []"
      :items-per-page="-1">
      <template #item.status="{ item }">
        <v-chip
          v-if="item.status"
          :color="getStatusColor(item.status.id)"
          size="small"
          variant="flat"
          >{{ item.status?.name }}
        </v-chip>
      </template>
      <template #item.author="{ item }">
        {{
          getPersonName(item.author, {
            initials: true,
          })
        }}
      </template>
      <template #item.executor="{ item }">
        {{
          getPersonName(item.executor, {
            initials: true,
          })
        }}
      </template>
      <template #bottom></template>
    </v-data-table>
    <content-not-found v-else></content-not-found>
  </div>
</template>

<script lang="ts">
import ContentNotFound from '@/components/ContentNotFound.vue'
import { protocolTaskHeaders } from '@/utils/tableHeaders'
import { getPersonName } from 'best-modules/utils/helpers'
import { useProtocol } from '../protocol'

export default {
  name: 'Tasks',
  components: { ContentNotFound },
  data() {
    return {
      protocolTaskHeaders,
    }
  },
  methods: { getPersonName },
  setup() {
    const { protocol } = useProtocol()
    const getStatusColor = (statusId: any) => {
      switch (statusId) {
        case 1:
          return 'yellow-lighten-1'
        case 2:
          return 'blue'
        case 3:
          return 'green'
        case 4:
          return 'red'
        case 5:
          return 'yellow-lighten-1'
      }
    }

    return {
      getStatusColor,
      protocol,
    }
  },
}
</script>

<style lang="scss" scoped></style>
